export default __webpack_public_path__ + "c423e62bf9c2ec03bd0c395a93072a88.png";